import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Grid, TextField, Menu, MenuItem, IconButton, Drawer, List, ListItem, ListItemText, Button, useMediaQuery, useTheme, Dialog, DialogTitle, DialogContent, DialogActions, FormHelperText, Divider  } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ProfileUpdate from './Profile';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { Link } from 'react-router-dom';
import logo from '../logo.jpeg';
import Slide from '@mui/material/Slide';
import InputAdornment from '@mui/material/InputAdornment';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PasswordIcon from '@mui/icons-material/Password';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { verifyMobileOtp, RegisterUser, UserLogin } from '../apiCalls';
import { toast } from 'react-toastify';
import { keyframes } from '@emotion/react';

const buttonStyle = {
  background: 'linear-gradient(to right, #0d7ae3 50%, white 50%)',
  backgroundSize: '200% 100%',
  backgroundPosition: '0% 50%',
  transition: 'background-position 1s',
  '&:hover': {
    backgroundPosition: '100% 50%',
    color: '#0d7ae3', // Ensure text remains visible on both backgrounds
  },
  color: 'white', // Ensure text remains visible on both backgrounds
};



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const NavBar = () => {

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [loginActive , setLoginActive] = useState(false);
  const [verifyBar , setVerifyBar] = useState(false);

  const [otp , setOtp] = useState("");

  const [resOtp , setResOtp] = useState("");

  const [is_login , setIsLogin] = useState(false);


  useEffect(()=>{
    const phone = localStorage.getItem("phone");
    const type = localStorage.getItem("type");
    const isLogin = localStorage.getItem("is_login");

    if(isLogin){
      setIsLogin(isLogin)
    }

  },[])




  const [registerData, setRegisterData] = useState({
    name: '',
    phone: '',
    email: '',
    password: '',
    confirmPassword: '',
    role:''
  });

  const [loginData, setLoginData] = useState({
    phone: '',
    password: '',
  });

  const [errors, setErrors] = useState({
    phone: '',
    email: '',
    password: '',
    confirmPassword: '',
  });

  // Validate phone number
  useEffect(() => {
    if (!loginActive && registerData.phone !== '') {
      const phoneRegex = /^\d{10}$/;
      setErrors(prevErrors => ({
        ...prevErrors,
        phone: phoneRegex.test(registerData.phone) ? '' : 'Phone number must be 10 digits'
      }));
    }
  }, [registerData.phone, loginActive]);

  // Validate email
  useEffect(() => {
    if (!loginActive && registerData.email !== '') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      setErrors(prevErrors => ({
        ...prevErrors,
        email: emailRegex.test(registerData.email) ? '' : 'Invalid email address'
      }));
    }
  }, [registerData.email, loginActive]);

  // Validate password
  useEffect(() => {
    if (!loginActive && registerData.password !== '') {
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      setErrors(prevErrors => ({
        ...prevErrors,
        password: passwordRegex.test(registerData.password)
          ? ''
          : 'Password must be at least 8 characters long and include 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character'
      }));
    }
  }, [registerData.password, loginActive]);

  useEffect(() => {
    if (!loginActive && registerData.confirmPassword !== '') {
      setErrors(prevErrors => ({
        ...prevErrors,
        confirmPassword: registerData.password === registerData.confirmPassword
          ? ''
          : 'Passwords do not match'
      }));
    }
  }, [registerData.confirmPassword, registerData.password, loginActive]);

  const [inputDisable , setInputDisable] = useState(false);

  const handlePhoneChange =async (phoneValue) => {

    setInputDisable(true)

    const data = {
      phone:phoneValue
    }

    const response = await verifyMobileOtp(data);  
    if (response.success === true) {
      setVerifyBar(true);
      setResOtp(response.otp)
      toast.success('OTP sent successfully');
    } else {
      toast.error('Failed to Verify OTP');
    }
  };

  const handleRegisterChange = (event) => {
    const { id, value } = event.target;
  
    setRegisterData(prevData => {
      const updatedData = {
        ...prevData,
        [id]: value
      };
  
      if (id === 'phone' && value.length === 10) {
        handlePhoneChange(value);
      }
  
      return updatedData;
    });
  };

  const handleRoleChange = (event) => {
    setRegisterData(prevData => ({
      ...prevData,
      role: event.target.value
    }));
  };

  const handleLoginChange = (event) => {
    const { id, value } = event.target;
    setLoginData(prevData => ({
      ...prevData,
      [id]: value
    }));
  };


  const verifyOtp = () =>{
      if(otp === resOtp){
        toast.success("OTP Verified Successfully");
        setVerifyBar(false);
      }else{
        toast.error("Incorrect OTP");
      }
  }


  const handleSignup = async() => {
    const { name, phone, password, email, role } = registerData;
  
    if (!name || !phone || !password || !email || !role) {
      toast.error('All fields are required.');
      return;
    }
  
    const data = {
      fullName: name,
      phone: phone,
      password: password,
      email: email,
      type: role
    }

    const response = await RegisterUser(data);  
    if (response.success === true) {
      setLoginActive(true);
      setRegisterData({
        name: '',
        phone: '',
        email: '',
        password: '',
        confirmPassword: '',
        role: ''
      });
      toast.success('Registred Successfully');
    } else {
      toast.error('Failed to Register');
    }
  
    console.log(data);
  }
  

  const handleLogin = async() => {
    const {phone, password } = loginData;
  
    if (!phone || !password) {
      toast.error('All fields are required.');
      return;
    }
  
    const data = {
      phone: phone,
      password: password,
    }

    const response = await UserLogin(data);  
    if (response.success === true) {
      setLoginData({
        phone: '',
        password: '',
      });
      setDialogOpen(false); 
      localStorage.setItem("phone" , response.phone);
      localStorage.setItem("type" , response.type);
      localStorage.setItem("is_login" , true);
      setLoginActive(true);
      toast.success('Login Successful');
    } else {
      toast.error('Failed to Login');
    }
    }
  

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };


  const [openMenu, setOpenMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  

  const handleDialogOpen = () => {
    const is_login = localStorage.getItem("is_login") === 'true';
    if(is_login){
      // window.location.href = "/dashboard";
      setOpenMenu(true);
    } else {
      setDialogOpen(true);
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setOpenMenu(false);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const menuItems = [
    { text: 'Home', path: '/' },
    { text: 'Individual', path: '/about' },
    { text: 'Projects', path: '/about' },
    { text: 'Added Value Service', path: '/about' },
    { text: 'Rent/Lease', path: '/about' },
    { text: 'Sell Property', path: '/about' },
    { text: 'Login/Register', path: '/login-register' },
  ];


  const [profileOpen , setProfileOpen] = useState(false);

  const handleProfileOpen = () => {
    setProfileOpen(true);
    handleMenuClose();
  }

  const handleProfileClose = () => {
    setProfileOpen(false)
  }

  return (
    <div>
      <ProfileUpdate openProfile={profileOpen} handleClose={handleProfileClose} />
      <AppBar position="fixed" sx={{ background: 'white', color: 'black' }}>
        <Toolbar>
          {isMobile ? (
            <>
              <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerOpen}>
                <MenuIcon />
              </IconButton>
              <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerClose}>
                <List>
                  {menuItems.map((item, index) => (
                    <ListItem button key={index} component={Link} to={item.path} onClick={item.text === 'Login/Register' ? handleDialogOpen : handleDrawerClose}>
                      <ListItemText primary={item.text} />
                    </ListItem>
                  ))}
                </List>
              </Drawer>
            </>
          ) : (
            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
            <img src={logo} alt="logo" style={{ width: '100px' }} />
            <div>
              {menuItems.map((item, index) => (
                <Button
                  key={index}
                  color="inherit"
                  sx={{ fontWeight: 'bold', textTransform: 'none', fontSize: '1rem' }}
                  component={item.text === 'Login/Register' ? 'button' : Link}
                  to={item.path}
                  onClick={item.text === 'Login/Register' ? handleDialogOpen : null}
                >
                  {item.text === 'Login/Register' ? <PersonOutlineOutlinedIcon /> : item.text}
                </Button>
              ))}
              <Menu
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <Grid  sx={{minWidth:250}}>
                  <Grid container direction='column' spacing={1.3}>
                    <Grid item mt={2} pb={1}>
                      <Grid container direction='column' spacing={1}>
                        <Grid item xs={12} sm={12} md={12} sx={{textAlign:'center'}}>
                          <Grid container justifyContent='space-between'>
                            <Grid item xs={4} sm={4} md={4} sx={{display:'flex',justifyContent:'center'}} >

                            </Grid>
                            <Grid item xs={4} sm={4} md={4} sx={{display:'flex',justifyContent:'center'}} >
                              <Typography variant="body1"><span style={{color:'#ffffff',background:'#1976d2' , borderRadius:'50%' , padding:'10px'}}>D</span></Typography>
                            </Grid>
                            <Grid item xs={4} sm={4} md={4} sx={{display:'flex',justifyContent:'center'}} >
                              <Typography variant="body1"><span><DriveFileRenameOutlineIcon sx={{cursor:'pointer'}} onClick={handleProfileOpen} /></span></Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} sx={{textAlign:'center'}}>
                          <Typography variant="body1" fontWeight='bold'>Dhanush</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} sx={{textAlign:'center'}}>
                          <Typography variant="body1">9999999999</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} sx={{textAlign:'center'}}>
                          <Typography variant="body1">Workofdhanu@gmail.com</Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Divider />
                    <Grid item sx={{paddingTop:'5px !important'}}>
                      <MenuItem fontWeight='bold' onClick={handleMenuClose} component={Link} to="/dashboard">Properties</MenuItem>
                    </Grid>
                    <Grid item>
                      <MenuItem fontWeight='bold' onClick={handleMenuClose} component={Link} to="/others">Others</MenuItem>
                    </Grid>
                  </Grid>
                </Grid>
              </Menu>
            </div>
          </div>
          )}
        </Toolbar>
      </AppBar>

      <Dialog open={dialogOpen} TransitionComponent={Transition} onClose={handleDialogClose}      
      PaperProps={{
        style: {
          minWidth: isMobile ? '90vw' : '50vw',
        },
      }} >
        <DialogContent sx={{padding:'0px'}}>
          <Grid>
            <Grid container justifyContent='space-between' direction='row'>
              <Grid 
                item 
                md={6} 
                sx={{ 
                  backgroundImage: 'url(https://baltimore-demo.b-cdn.net/wp-content/uploads/2021/10/house-copy.webp)',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  width: '100%',
                  height: 'auto', // Ensure the height is set to a specific value or to fill the parent container
                  minHeight: '300px', // You can adjust this value to fit your design
                }}
              >
                {/* Add any other content here if needed */}
              </Grid>
              <Grid item md={6}>
                  {loginActive ? (
                    <>
                      <Grid item md={12}>
                        <Grid container justifyContent='space-between' direction='column' spacing={1.7} sx={{padding:{xs:'none',sm:'none',md:'35px'}}} >
                          <Grid item xs={12} sm={12} md={12}>
                            <Typography variant='h6' sx={{fontWeight:'bold'}}>Login</Typography>
                          </Grid>
                          <Grid item xs={12} sm={12} md={12}>
                            <TextField
                              id="phone"
                              label="Phone"
                              variant="outlined"
                              fullWidth
                              value={loginData.phone}
                              error={!!errors.phone}
                              helperText={errors.phone}
                              onChange={handleLoginChange}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton>
                                      <LocalPhoneIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />                          
                          </Grid>
                          <Grid item xs={12} sm={12} md={12}>
                            <TextField
                              id="password"
                              label="Password"
                              variant="outlined"
                              fullWidth
                              type="password"
                              value={loginData.password}
                              onChange={handleLoginChange}
                              error={!!errors.password}
                              helperText={errors.password}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton>
                                      <PasswordIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />    
                          </Grid>
                          <Grid item xs={12} sm={12} md={12} sx={{display:'flex',justifyContent:'flex-end'}}>
                            <Button sx={buttonStyle} variant='contained' size="large" fullWidth onClick={handleLogin}>Login</Button>
                          </Grid>
                          <Grid item md={12} sx={{display:'flex',justifyContent:'center'}}>
                            <Typography variant='subtitle1'>Create new account? <span onClick={() => {setLoginActive(false)}} style={{cursor:'pointer',color:'#0d7ae3'}} >Create</span></Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  ):(
                    <>
                      <Grid item md={12} sx={{maxHeight:'400px',overflow:'auto',margin:'40px 0'}}>
                        <Grid container justifyContent='space-between' direction='column' spacing={1.7} sx={{padding:{xs:'none',sm:'none',md:' 0px 35px'}}} >
                          <Grid item md={12}>
                            <Typography variant='h6' sx={{fontWeight:'bold'}}>Register</Typography>
                          </Grid>
                          <Grid item xs={12} sm={12} md={12}>
                            <TextField
                              id="name"
                              label="Name"
                              variant="outlined"
                              size="small"
                              fullWidth
                              value={registerData.name}
                              onChange={handleRegisterChange}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton>
                                      <PersonIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={12} md={12}>
                            <TextField
                              id="phone"
                              label="Phone"
                              size="small"
                              variant="outlined"
                              fullWidth
                              disabled={inputDisable}
                              value={registerData.phone}
                              onChange={handleRegisterChange}
                              error={!!errors.phone}
                              helperText={errors.phone}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton>
                                      <LocalPhoneIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                          {verifyBar && (
                            <Grid item xs={12} sm={12} md={12}>
                              <Grid container direction="row">
                                <Grid item xs={6} sm={6} md={6}>
                                  <TextField id="outlined-basic" label="OTP" variant="outlined" fullWidth size='small' value={otp} onChange={(e)=>{setOtp(e.target.value)}} />
                                </Grid>
                                <Grid item xs={6} sm={6} md={6}>
                                  <Button sx={{marginLeft:'20px'}} variant='contained' disabled={!otp.length} onClick={verifyOtp}>Verify</Button>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                          <Grid item xs={12} sm={12} md={12}>
                            <TextField
                              id="email"
                              label="Email"
                              variant="outlined"
                              size="small"
                              fullWidth
                              value={registerData.email}
                              onChange={handleRegisterChange}
                              error={!!errors.email}
                              helperText={errors.email}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton>
                                      <EmailIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={12} md={12}>
                            <TextField
                              id="password"
                              label="Password"
                              variant="outlined"
                              size="small"
                              fullWidth
                              type="password"
                              value={registerData.password}
                              onChange={handleRegisterChange}
                              error={!!errors.password}
                              helperText={errors.password}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton>
                                      <PasswordIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={12} md={12}>
                            <TextField
                              id="confirmPassword"
                              label="Confirm Password"
                              size="small"
                              variant="outlined"
                              fullWidth
                              type="password"
                              value={registerData.confirmPassword}
                              onChange={handleRegisterChange}
                              error={!!errors.confirmPassword}
                              helperText={errors.confirmPassword}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton>
                                      <PasswordIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={12} ms={12}>
                            <FormControl component="fieldset" error={!!errors.gender}>
                              <FormLabel component="legend">Role</FormLabel>
                              <RadioGroup
                                aria-labelledby="gender-radio-buttons-group"
                                name="gender-radio-buttons-group"
                                value={registerData.role}
                                onChange={handleRoleChange}
                                row
                              >
                                <FormControlLabel value="Buyer" control={<Radio />} label="Buyer" />
                                <FormControlLabel value="Seller" control={<Radio />} label="Seller" />
                                <FormControlLabel value="Agent" control={<Radio />} label="Agent" />
                                <FormControlLabel value="B2B" control={<Radio />} label="B2B" />
                              </RadioGroup>
                              {errors.gender && <FormHelperText>{errors.gender}</FormHelperText>}
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={12} md={12} sx={{display:'flex',justifyContent:'flex-end'}}>
                            <Button
                              variant="contained"
                              size="large"
                              fullWidth
                              onClick={handleSignup}
                              sx={buttonStyle}
                            >
                              Submit
                            </Button>
                          </Grid>
                          <Grid item md={12} sx={{display:'flex',justifyContent:'center'}}>
                            <Typography variant='subtitle1'>Already have an account? <span onClick={() => {setLoginActive(true)}} style={{cursor:'pointer',color:'#0d7ae3'}} >Login</span></Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  )}
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default NavBar;
